import { render, staticRenderFns } from "./mBetKeyboard.vue?vue&type=template&id=9f8d7afc&scoped=true"
import script from "./mBetKeyboard.vue?vue&type=script&lang=js"
export * from "./mBetKeyboard.vue?vue&type=script&lang=js"
import style0 from "./mBetKeyboard.vue?vue&type=style&index=0&id=9f8d7afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8d7afc",
  null
  
)

export default component.exports